import Router from "next/router";
import { getPath } from "../../utils/getPath";

const push = Router.push.bind(Router);
const replace = Router.replace.bind(Router);

const asPath = () => getPath(window.location);

export default { push, replace, asPath };
